// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__g6q2R","withSidebar":"Layout_withSidebar__w7Owk","content":"Layout_content__XQanG"};